/// Shop-specific scripts
function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? '<b>'+h+'</b>' + (h == 1 ? "hr " : "hrs ") : "";
    var mDisplay = m > 0 ? '<b>'+m+'</b>' + (m == 1 ? "min " : "mins ") : "";
    var sDisplay = s + "s";
    return hDisplay + mDisplay + sDisplay; 
}
function timeTil(lowTides, highTides)
{
  var currTime = new Date().getTime() / 1000;
  var nextLow;
  var prevLow = lowTides[0] - ( lowTides[1] - lowTides[0]);//estimate time diff in case there isn't one
  var i;
  for (i = 0; i < lowTides.length; i++) {
      if (lowTides[i] >= currTime) {
          nextLow = lowTides[i];
          if(i>0){
              prevLow = lowTides[(i-1)];
          }
          break;
      }
  }
  
  var nextHigh;
  var prevHigh = highTides[0] - ( highTides[1] - highTides[0]);//estimate time diff in case there isn't one
  var j;
  for (j = 0; j < highTides.length; j++) {
      if (highTides[j] >= currTime) {
          nextHigh = highTides[j];
          if(j>0){
              prevHigh = highTides[(j-1)];
          }
          break;
      }
  }
  var timeNow = new Date().getTime() / 1000;
		
	var timeTilLow = secondsToHms(nextLow - timeNow);
	var timeTilHigh = secondsToHms(nextHigh - timeNow);
	
	if(timeTilLow<0){
		prevLow = nextLow;
		nextLow = lowTides[(i+1)];
	}
	if(timeTilHigh<0){
		prevHigh = nextHigh;
		nextHigh = highTides[(j+1)];
	}
	
	var tideState;
	var timeDiff;
	var tideRatio;
	var tidePercent;
	var rotate;
	
	if(nextLow < nextHigh){//dropping tide (i.e. next low is first)
		timeDiff = nextLow - prevHigh;
		//timeDiff = nextHigh - nextLow;
		//tideRatio = 1 - ((timeNow - prevHigh) / timeDiff);
		tideRatio = ((nextLow - timeNow) / timeDiff);
		tideState = 'falling';
		rotate = 180 - Math.round((tideRatio * 180));
		tidePercent = Math.round(tideRatio * 100);
	}
	else{//rising
		timeDiff = nextHigh - prevLow;
		//timeDiff = nextLow - nextHigh;
		//tideRatio = ((timeNow - prevLow) / timeDiff);
		tideRatio = ((nextHigh - timeNow) / timeDiff);
		tideState = 'rising';
		rotate = Math.round(360 - (tideRatio * 180));
		tidePercent = 100 - Math.round(tideRatio * 100);
	}
	
	console.log('Now: ' + timeNow + ' | prevLow: ' + prevLow + ' | prevHigh: ' + prevHigh + ' | nextLow: ' + nextLow + ' | nextHigh: ' + nextHigh + ' | timeDiff:' + timeDiff);
	console.log(tideState);
	console.log(tideRatio);
	console.log(rotate);
  return rotate;
}

function getCurrentTidalData(customLat, CustomLong)
{
  var currentDate = new Date();
  currentDate.setHours(currentDate.getHours());
  var timeInMillisecond = currentDate.getTime();
  var unixTimestamp = Math.floor(currentDate.getTime() / 1000);
  var customUrl = "https://www.worldtides.info/api/v3?extremes&datum=CD&date=today&lat="+customLat+"&lon="+CustomLong+"&timezone=Europe/London&localtime&days=1&key=6430b259-12ea-4048-a21f-d689c6d75108";
  $.ajax({
    url: customUrl,
    dataType: 'json',
    type: 'get',
    success: function (data) {
      if(data.extremes.length > 0)
      {
        var customHtml = '';
        var customNewHtml = '';
        var currentTideType = "";
        var lowTides = [];
        var highTides = [];
        $(data.extremes).each(function(index, element){
          var tideHeight = element.height.toFixed(2);
          var tideType = element.type;
          var tideUnix = element.dt;
          if(tideUnix > unixTimestamp)
          {

          }
          else
          {
            currentTideType = tideType;
          }
          if(tideType == "Low")
          {
            lowTides.push(tideUnix);
          }
          else
          {
            highTides.push(tideUnix);
          }
          // var tideTime = new Date(element.date).toLocaleTimeString('en',{ timeStyle: 'short', hour12: false, timeZone:'Europe/London' });
          var getOriginalUTCDate = element.date;
          getOriginalUTCDate = getOriginalUTCDate.split("T");
          var getTimeFromDate = getOriginalUTCDate[1];
          getTimeFromDate = getTimeFromDate.split("+");
          getTimeFromDate = getTimeFromDate[0];
          getTimeFromDate = getTimeFromDate.split(":");
          var tideTime = getTimeFromDate[0]+":"+getTimeFromDate[1];
          customHtml += '<div class="tide-times-current-tide-single-level data-box">';
            customHtml += '<div class="tide-times-current-tide-single-level-row">';
              customHtml += '<div class="tide-times-current-tide-single-level-column">';
                customHtml += '<div class="tide-times-current-tide-single-level-tide">';
                  customHtml += '<p>'+tideType+'</p>';
                customHtml += '</div>';
              customHtml += '</div>';
              customHtml += '<div class="tide-times-current-tide-single-level-column">';
                customHtml += '<div class="tide-times-current-tide-single-level-time">';
                  customHtml += '<p>'+tideTime+'</p>';
                customHtml += '</div>';
              customHtml += '</div>';
              customHtml += '<div class="tide-times-current-tide-single-level-column">';
                customHtml += '<div class="tide-times-current-tide-single-level-height">';
                  customHtml += '<p>'+tideHeight+'m</p>';
                customHtml += '</div>';
              customHtml += '</div>';
            customHtml += '</div>';
          customHtml += '</div>';
          customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-single-list data-box">';
            customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-row">';
              customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-column">';
                customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-tide">';
                  customNewHtml += '<p>'+tideType+'</p>';
                customNewHtml += '</div>';
              customNewHtml += '</div>';
              customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-column">';
                customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-time">';
                  customNewHtml += '<p>'+tideTime+'</p>';
                customNewHtml += '</div>';
              customNewHtml += '</div>';
              customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-column">';
                customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-height">';
                  customNewHtml += '<p>'+tideHeight+'m</p>';
                customNewHtml += '</div>';
              customNewHtml += '</div>';
            customNewHtml += '</div>';
          customNewHtml += '</div>';
        });
        if(typeof customHtml != "undefined" && customHtml != null && customHtml != "")
        {
          $(".tide-times-current-tide-single-level.data-box").remove();
          $(".tide-times-current-tide-levels-listing").append(customHtml);
        }
        if(typeof customNewHtml != "undefined" && customNewHtml != null && customNewHtml != "")
        {
          $(".tide-times-clock-more-info-blocks-tide-single-list.data-box").remove();
          $(".tide-times-clock-more-info-blocks-tide-lists").append(customNewHtml);
        }
        if(typeof currentTideType != "undefined" && currentTideType != null && currentTideType != "")
        {
          var nextDay = new Date();
            nextDay.setDate(nextDay.getDate()+1);
            var nextDayYear = nextDay.getFullYear();
            var nextDayDate = ('0' + nextDay.getDate()).slice(-2);
            var nextDayMonth = ("0" + (nextDay.getMonth() + 1)).slice(-2);
            var customDate = nextDayYear+"-"+nextDayMonth+"-"+nextDayDate;
            var customUrl = "https://www.worldtides.info/api/v3?extremes&datum=CD&date="+customDate+"&lat="+customLat+"&lon="+CustomLong+"&timezone=Europe/London&localtime&days=1&key=6430b259-12ea-4048-a21f-d689c6d75108";
            $.ajax({
              url: customUrl,
              dataType: 'json',
              type: 'get',
              success: function (nextDayData) {
                if(nextDayData.extremes.length > 0)
                {
                  $(nextDayData.extremes).each(function(nextDayIndex, nextDayElement){
                    var nextDayTideType = nextDayElement.type;
                    var nextDayTideUnix = nextDayElement.dt;
                    if(nextDayTideType == "Low")
                    {
                      lowTides.push(nextDayTideUnix);
                    }
                    else
                    {
                      highTides.push(nextDayTideUnix);
                    }
                  });
                  var getRotate = timeTil(lowTides, highTides);
                  $('.tide-times-current-tide-meter-pin').css('transform',"translate(-50%, -50%) rotate("+getRotate+"deg)");
                  if (typeof getRotate != "undefined" && getRotate != null && getRotate != "")
                  {
                    if(getRotate >= 0 && getRotate <= 45)
                    {
                      $(".landing-page-tide-times-clocks-wrapper").removeClass("default");
                      $(".landing-page-tide-times-clocks-wrapper").addClass("high-current");
                    }
                    else if(getRotate >= 46 && getRotate <= 110)
                    {
                      $(".landing-page-tide-times-clocks-wrapper").removeClass("default");
                      $(".landing-page-tide-times-clocks-wrapper").addClass("ebb-current");
                    }
                    else if(getRotate >= 111 && getRotate <= 245)
                    {
                      $(".landing-page-tide-times-clocks-wrapper").removeClass("default");
                      $(".landing-page-tide-times-clocks-wrapper").addClass("low-current");
                    }
                    else if(getRotate >= 246 && getRotate <= 305)
                    {
                      $(".landing-page-tide-times-clocks-wrapper").removeClass("default");
                      $(".landing-page-tide-times-clocks-wrapper").addClass("flood-current");
                    }
                    else if(getRotate >= 306 && getRotate <= 360)
                    {
                      $(".landing-page-tide-times-clocks-wrapper").removeClass("default");
                      $(".landing-page-tide-times-clocks-wrapper").addClass("high-current");
                    }
                  }  
                }
              },
              error: function(XMLHttpRequest) {
                alert(XMLHttpRequest.responseJSON.description);
              }
            });  
          // currentTideType = currentTideType.toLowerCase()+"-current";
          // $(".landing-page-tide-times-clocks-wrapper").removeClass("default");
          // $(".landing-page-tide-times-clocks-wrapper").addClass(currentTideType);
        }
        var currentYear = currentDate.getFullYear();
        var currentDateNo = currentDate.getDate();
        var currentMonthNo = ("0" + (currentDate.getMonth() + 1)).slice(-2);
        var fullDate = currentDateNo+"/"+currentMonthNo+"/"+currentYear;
        $(".current-date").html("");
        $(".current-date").html(fullDate);
      }
    },
    error: function(XMLHttpRequest) {
      alert(XMLHttpRequest.responseJSON.description);
    }
  });
}
function getDateWiseTidalData(customDate, customLat, CustomLong)
{
  var currentDate = new Date(customDate);
  currentDate.setHours(currentDate.getHours());
  var timeInMillisecond = currentDate.getTime();
  var unixTimestamp = Math.floor(currentDate.getTime() / 1000);
  var customUrl = "https://www.worldtides.info/api/v3?extremes&datum=CD&date="+customDate+"&lat="+customLat+"&lon="+CustomLong+"&timezone=Europe/London&localtime&days=1&key=6430b259-12ea-4048-a21f-d689c6d75108";
  $.ajax({
    url: customUrl,
    dataType: 'json',
    type: 'get',
    success: function (data) {
      if(data.extremes.length > 0)
      {
        var customNewHtml = '';
        var currentTideType = "";
        $(data.extremes).each(function(index, element){
          var tideHeight = element.height.toFixed(2);
          var tideType = element.type;
          var tideUnix = element.dt;
          if(tideUnix > unixTimestamp)
          {

          }
          else
          {
            currentTideType = tideType;
          }
          var getOriginalUTCDate = element.date;
          getOriginalUTCDate = getOriginalUTCDate.split("T");
          var getTimeFromDate = getOriginalUTCDate[1];
          getTimeFromDate = getTimeFromDate.split("+");
          getTimeFromDate = getTimeFromDate[0];
          getTimeFromDate = getTimeFromDate.split(":");
          var tideTime = getTimeFromDate[0]+":"+getTimeFromDate[1];
          customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-single-list data-box">';
            customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-row">';
              customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-column">';
                customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-tide">';
                  customNewHtml += '<p>'+tideType+'</p>';
                customNewHtml += '</div>';
              customNewHtml += '</div>';
              customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-column">';
                customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-time">';
                  customNewHtml += '<p>'+tideTime+'</p>';
                customNewHtml += '</div>';
              customNewHtml += '</div>';
              customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-column">';
                customNewHtml += '<div class="tide-times-clock-more-info-blocks-tide-lists-height">';
                  customNewHtml += '<p>'+tideHeight+'m</p>';
                customNewHtml += '</div>';
              customNewHtml += '</div>';
            customNewHtml += '</div>';
          customNewHtml += '</div>';
        });
        if(typeof customNewHtml != "undefined" && customNewHtml != null && customNewHtml != "")
        {
          $(".tide-times-clock-more-info-blocks-tide-single-list.data-box").remove();
          $(".tide-times-clock-more-info-blocks-tide-lists").append(customNewHtml);
        }
        var currentYear = currentDate.getFullYear();
        var currentDateNo = currentDate.getDate();
        var currentMonthNo = ("0" + (currentDate.getMonth() + 1)).slice(-2);
        var fullDate = currentDateNo+"/"+currentMonthNo+"/"+currentYear;
        $(".current-date").html("");
        $(".current-date").html(fullDate);
      }
    },
    error: function(XMLHttpRequest) {
      alert(XMLHttpRequest.responseJSON.description);
    }
  });
}
if($(".tide-times-clock-banner-wrapper").length > 0)
{
  var getLat = $(".tide-times-clock-banner-wrapper").attr("data-lat");
  var getLong = $(".tide-times-clock-banner-wrapper").attr("data-long");
  if(typeof getLat != "undefined" && getLat != null && getLat != "" &&
     typeof getLong != "undefined" && getLong != null && getLong != "")
  {
    getLat = $.trim(getLat);
    getLong = $.trim(getLong);
    getCurrentTidalData(getLat, getLong);
  }
  var getTitle = $(".tide-time-custom-banner-title").text();
  var getLocation = $(".tide-time-custom-banner-location").text();
  var getSecondSectionTitle = $(".tide-times-clock-more-info-title h2").text();
  $(".custom-tide-times-title").html("");
  $(".custom-tide-times-title").html(getTitle);
  $(".custom-tide-times-full-title").html("");
  $(".custom-tide-times-full-title").html(getTitle+", "+getLocation);
  $(".tide-times-clock-product-wrapper .home-tide-clock-form-button a").html("");
  $(".tide-times-clock-product-wrapper .home-tide-clock-form-button a").html("shop "+getTitle+" tide clock");
}
if($(".custom-tide-clock-datepicker").length > 0)
{
  var currentDate = new Date();
  var dateGetLat = $(".tide-times-clock-banner-wrapper").attr("data-lat");
  var dateGetLong = $(".tide-times-clock-banner-wrapper").attr("data-long");
  if(typeof dateGetLat != "undefined" && dateGetLat != null && dateGetLat != "" &&
     typeof dateGetLong != "undefined" && dateGetLong != null && dateGetLong != "")
  {
    dateGetLat = $.trim(dateGetLat);
    dateGetLong = $.trim(dateGetLong);
    $(".custom-tide-clock-datepicker").datepicker({
        // minDate: 0
        dayNamesMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dateFormat: 'yy-mm-dd',
        onSelect: function(dateText, inst) {
          getDateWiseTidalData(dateText, dateGetLat, dateGetLong);
        }
    });
  }
}
function mobileLayout() {
  return $(window).width() < 768;
}
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

var lightbox_min_window_width = 768;
var lightbox_min_window_height = 580;

$('html').removeClass('no-js');
$(document).ready(function(){
   $("a.close-announcement-bar").on("click", function(e){
    e.preventDefault();
    $("body").removeClass("custom-announcement-banner");
    $("#pageheader").removeAttr("style");
    $(this).parent().remove();
  });
  if($(".announcement-description").length > 0)
  {
    $("body").addClass("custom-announcement-banner");
    var currentScroll = $(window).scrollTop();
    if($("body").hasClass("custom-announcement-banner"))
    {
      if($(window).width() > 767)
      {
        $("#pageheader").css("top", "50px");  
      }
      else
      {
        $("#mobile-nav").css("top", "35px"); 
      }
    }
    $(window).on("scroll", function(){
      var currentScroll = $(window).scrollTop();
      if($("body").hasClass("custom-announcement-banner"))
      {
        if($(window).width() > 767)
        {
          $("#pageheader").css("top", "50px"); 
        }
        else
        {
          $("#mobile-nav").css("top", "35px"); 
        }
      }
    });
  }
  if($(".bookmark-banner-section-desktop-text").length > 0 && $(".bookmark-banner-section-mobile-text").length > 0)
  {
    var getBookmarkCookie = $.cookie("bookmark-banner");
    if(typeof getBookmarkCookie != "undefined" && getBookmarkCookie != null && getBookmarkCookie != "" && getBookmarkCookie == "Yes")
    {

    }
    else
    {
      var desktopHtml = $(".bookmark-banner-section-desktop-text").html();
      var mobileHtml = $(".bookmark-banner-section-mobile-text").html();
      var customHeaderHtml = '';
      customHeaderHtml += '<div class="bookmark-banner-wrapper">';
        customHeaderHtml += '<div class="container">';
          customHeaderHtml += '<div class="bookmark-banner-desktop-text">';
            customHeaderHtml += desktopHtml;
          customHeaderHtml += '</div>';
          customHeaderHtml += '<div class="bookmark-banner-mobile-text">';
            customHeaderHtml += mobileHtml;
          customHeaderHtml += '</div>';
        customHeaderHtml += '</div>';
        customHeaderHtml += '<div class="bookmark-cross-icon">';
          customHeaderHtml += '<a href="#"><img src="https://cdn.shopify.com/s/files/1/0745/6891/files/bookmark-cross-icon.svg?v=1690527940" alt=""/></a>';
        customHeaderHtml += '</div>';
      customHeaderHtml += '</div>';
      $("#shopify-section-header").append(customHeaderHtml);
      var getPlatform = navigator.platform;
      getPlatform = getPlatform.toLowerCase();
      if($(window).width() > 767)
      {
        if(getPlatform.indexOf('mac') != -1 || getPlatform.indexOf('iphone') != -1 || getPlatform.indexOf('ipad') != -1) 
        {
          $(document).find(".bookmark-banner-desktop-text p span .chrome").css("display", "none");
          $(document).find(".bookmark-banner-desktop-text p span .safari").css("display", "inline-block");
        }
        else
        {
          $(document).find(".bookmark-banner-desktop-text p span .safari").css("display", "none");
          $(document).find(".bookmark-banner-desktop-text p span .chrome").css("display", "inline-block");
        }  
      }
      else
      {
        if(getPlatform.indexOf('mac') != -1 || getPlatform.indexOf('iphone') != -1 || getPlatform.indexOf('ipad') != -1) 
        {
          $(document).find(".bookmark-banner-mobile-text p span .chrome").css("display", "none");
          $(document).find(".bookmark-banner-mobile-text p span .safari").css("display", "inline-block");
        }
        if(getPlatform.indexOf('android') != -1 || getPlatform.indexOf('linux') != -1) 
        {
          $(document).find(".bookmark-banner-mobile-text p span .safari").css("display", "none");
          $(document).find(".bookmark-banner-mobile-text p span .chrome").css("display", "inline-block");
        }  
      }
      $(".bookmark-cross-icon a").on("click", function(e){
        e.preventDefault();
        $.cookie('bookmark-banner', 'Yes', {
           expires: 100, 
           path:'/'
        });
        $(".bookmark-banner-wrapper").remove();
        $("body").removeClass("custom-bookmark-banner");
        $("#pageheader").css("top", "0px");
        $("#mobile-nav").css("top", "0px");
      });
      $("body").addClass("custom-bookmark-banner");
      var currentScroll = $(window).scrollTop();
      if($("body").hasClass("custom-bookmark-banner"))
      {
        if($(window).width() > 767)
        {
          if(currentScroll > 45)
          {
            $("#pageheader").css("top", "0px");
          }
          else
          {
            $("#pageheader").css("top", "45px");
          }  
        }
        else
        {
          if(currentScroll > 30)
          {
            $("#mobile-nav").css("top", "0px");
          }
          else
          {
            $("#mobile-nav").css("top", "30px");
          }  
        }
      }
      $(window).on("scroll", function(){
        var currentScroll = $(window).scrollTop();
        if($("body").hasClass("custom-bookmark-banner"))
        {
          if($(window).width() > 767)
          {
            if(currentScroll > 45)
            {
              $("#pageheader").css("top", "0px");
            }
            else
            {
              $("#pageheader").css("top", "45px");
            }  
          }
          else
          {
            if(currentScroll > 30)
            {
              $("#mobile-nav").css("top", "0px");
            }
            else
            {
              $("#mobile-nav").css("top", "30px");
            }  
          }
        }
      });
    }
  }
});
jQuery(function($){
  function removeVslyAttributes() {
    $.getJSON('/cart.json', function (cart_data) {
        if (cart_data.attributes) {
            // Create a new object to hold the attributes to remove
            var updatedAttributes = {};

            // Loop through the cart attributes and check for ones starting with "vsly" (case-insensitive)
            $.each(cart_data.attributes, function(key, value) {
                // Convert the key to lowercase and check if it starts with "vsly"
                if (key.toLowerCase().startsWith('vsly')) {
                    updatedAttributes[key] = "";
                } else {
                    // Otherwise, keep the attribute in the updatedAttributes object
                    updatedAttributes[key] = value;
                }
            });

            // Now, update the cart with the remaining attributes using $.ajax
            $.ajax({
                url: '/cart/update.js',
                type: 'POST',
                data: {
                    attributes: updatedAttributes
                },
                dataType: 'json',
                success: function(updatedCart) {
                    // console.log('Updated cart without vsly attributes:', updatedCart);
                },
                error: function(xhr, status, error) {
                    console.log('Error updating cart:', error);
                }
            });
        }
    });
}

// Call the function once to remove attributes initially
removeVslyAttributes();

// Set an interval to remove the attributes every 2 seconds (2000 milliseconds)
setInterval(removeVslyAttributes, 2000);
  if(jQuery('.lazy').length)
  {
  	jQuery('.lazy').lazy();
  }
  $('.shopify-currency-form select').on('change', function() {
    $(this).parents('form').submit();
  });

  /// Header images
  var $head_bg = $('#pageheader img.background');
  //If header exists... (remember switch from port->land on 7" tablet)
  if($head_bg.length > 0) {
    var fillModeIsCover = $('#pageheader .head-img-cont.fillmode-cover').length == 1;
    $('body').addClass('header-has-bg');
    if(fillModeIsCover) {
      $head_bg.willFillParent({ closest: '.head-img-cont', windowEvent: 'updateheaderimg debouncedresize' });
    }
    $head_bg.imagesLoaded(function(){
      
      $head_bg.animate({opacity:1}, 500);
      $(window).trigger('updateheaderimg');
    });

    
  }

  /// Galleries (only on large screens)
  if($(window).height() >= lightbox_min_window_height && $(window).width() >= lightbox_min_window_width) {
    $('a[rel="gallery"]').colorbox({rel:'gallery'});
  }

  /// Main nav

  /// Sub-navs (aria-haspopup is for IE touchscreens)
  $('#pageheader .nav ul li:has(ul)').addClass('has-children').children('a').attr('aria-haspopup', 'true');

  //Remove aria from subnav if it is permanently visible
  
  $('#pageheader .nav ul li.has-children ul a').attr('aria-haspopup', 'false');
  

  //Double tap plugin courtesy of http://osvaldas.info/drop-down-navigation-responsive-and-touch-friendly
  //Handles showing dropdowns nicely on all devices. Only needed when not using mobile nav.
  if($('#pageheader .links-etc').css('position') != 'fixed') {
    $('#pageheader .nav > ul > li.has-children').doubleTapToGo();
  }

  //If expanding dropdown, make sure it's fully visible
  $('#pageheader').on('mouseenter', '.nav > ul > li.has-children', function(){
    var $dropdown = $(this).children('ul');
    $dropdown.toggleClass('anchor-right', $(this).offset().left + $dropdown.width() > $('#pageheader').width());
  });

  // Expanding sub-sub-nav
  $('#pageheader').on('click', '.nav li.has-children > a', function(){
    var $sub = $(this).siblings('ul');
    if($sub.css('min-height') == '1px') { // Make sure it's allowed to expand
      if($(this).parent().toggleClass('reveal').hasClass('reveal')) {
        $sub.slideDown(250);
      } else {
        $sub.slideUp(250);
      }
      return false;
    }
  });
  
  
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  $('.slider-for').on('lazyLoaded', function(event, slick, currentSlide, nextSlide){
    // $('.image-zoom').each(function(){
//      $(this)
//         .wrap('<span style="display:inline-block"></span>')
//         .css('display', 'block')
//         .parent()
//         .zoom({
//           url: $(this).find('img').attr('data-zoom')
//         });
//     });  
     
  });
  $('#customers-testimonials').owlCarousel({
		loop: true,
		center: true,
		items: 1,
		margin: 0,
		autoplay: true,
		dots:true,
		autoplayTimeout: 8500,
		smartSpeed: 450,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>']
	});
	$('#customers-testimonials-2-page').owlCarousel({
		loop: true,
		center: false,
		items: 1,
		margin: 5,
		autoplay: true,
		dots:true,
        nav:true,
		autoplayTimeout: 8500,
		smartSpeed: 450,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      	responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1170: {
				items: 3
			}
		}
	});
  	$('#customers_gallery').owlCarousel( {
		loop: true,
		center: false,
		items: 1,
		margin: 5,
		autoplay: true,
		dots:true,
        nav:true,
		autoplayTimeout: 8500,
        lazyLoad:true,
		smartSpeed: 450,
  	    navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
		responsive: {
			0: {
				items: 1,
                dots:false
			},
			768: {
				items: 2
			},
			1170: {
				items: 3
			}
		}
	});

  
  

  /// Mobile nav
  $(document).on('click', '.mobile-nav-toggle', function(e){
    e.preventDefault();
    $('body').toggleClass('reveal-mobile-nav');
  });
  $('<a href="#" class="mobile-nav-toggle" id="mobile-nav-return"></a>').appendTo('body');

  /// Button to scroll to the top (I've never really understood the point of these)
  $(window).on('scroll', function(){
    $('body').toggleClass('reveal-scroll-top', $(window).scrollTop() > 500);
  });
  $('#scroll-top').on('click', function(e){
    e.preventDefault();
    $('html:not(:animated),body:not(:animated)').animate({ scrollTop: 0}, 500 );
  });

  /// Modal search
  $(document).on('click', 'a[href="/search"], #search-modal', function(e){
    e.preventDefault();
    $('body').toggleClass('reveal-search-modal');
    if($('body').hasClass('reveal-search-modal')) {
      $('#search-modal input[name="q"]').focus();
    }
  }).on('click', '#search-modal form', function(e){
    e.stopPropagation(); // Don't trigger click on parents
  });

  /// Any slideshows?
  var defaultFlexsliderOpts = {
    controlNav: false,
    animation: 'fade', // 'slide' will also work
    slideshowSpeed: 4000 // delay between changing slides, default: 7000 (milliseconds)
  };
  $('.flexslider').flexslider(defaultFlexsliderOpts);

  /// Text that scales up/down based on container width
  var full_site_width = 1024;
  $(window).on('resizeScalingText debouncedresize', function(){
    $('.scaled-text').each(function(){
      var $base = $(this).closest('.scaled-text-base');
      var scale = $base.width() / (typeof $base.data('text-scale-from') != 'undefined' ? $base.data('text-scale-from') : full_site_width);
      $(this).css('font-size', (scale * 100) + '%');
  	});
  }).trigger('resizeScalingText');

     /* Slick slider for the gallary */
  	  window.slickSlider = $('.product-photos .main').slick({
  		dots: false,
      infinite: false,
      lazyLoad: 'ondemand'  
    });
  /// Gallery
  $('.product-photos').on('click', '.thumbnails .thumb', function(e){
    e.preventDefault();
    var $photoCont = $(this).closest('.product-photos');
    var $imgToChange = $photoCont.find('.main img');
    if($imgToChange.fadeToAnotherImage($(this).data('display-url'))) {
      $photoCont.find('.main a').attr('href', $(this).attr('href'));
      $(this).addClass('active').siblings('.active').removeClass('active');
    }
  }).on('click', '.load-all-thumbs', function(){
    //Expand all thumbs, removing gallery feature
    var $cont = $(this).closest('.product-photos').addClass('expanded-all');
    var $thumbs = $cont.find('.thumbnails');
    //Lightboxes?
    var usingLightbox = $cont.find('.main a').length > 0;
    //Revert main image to first thumbnail
    $thumbs.find('.thumb:first').click();
    //Create new images
    $thumbs.find('.thumb:not(:first)').each(function(index){
      var $img = $('<img/>').attr({ src: $(this).data('display-url'), alt: $(this).attr('title') }).hide();
      var $row = $('<div class="main exp-image loading-img"/>');
      if(usingLightbox) {
        $row.append( $('<a/>').attr({ href: $(this).attr('href'), title: $(this).attr('title') }).append($img) );
      } else {
        $row.append($img);
      }
      $row.appendTo($cont).imagesLoaded(function(){
        $row.height($row.height());
        $img.css('opacity', 0).show().animate({opacity:1}, 2000);
        $row.animate({height: $img.height()}, 1000, function(){
          $(this).css('height', '');
        });
      });
    });
    $thumbs.remove();
    return false;
  }).on('click', '.main a', function(e){
    e.preventDefault();
    //Don't do anything if the screen isn't very tall, otherwise, lightbox!
    if($(window).height() >= lightbox_min_window_height && $(window).width() >= lightbox_min_window_width) {
      var $prodPhotoCont = $(this).closest('.product-photos');
      if($prodPhotoCont.find('img').length == 1) {
        //One image only?
        $.colorbox({ href: $(this).attr('href') });
      } else {
        //Many images. Dupe thumbs to create a faux-gallery
        var imgSel = $prodPhotoCont.find('.main').length > 1 ? '.main' : '.thumbnails';
        $('#gallery-cont').remove();
        var $galleryCont = $('<div id="gallery-cont"/>').append(
          $prodPhotoCont.find(imgSel).find('a:has(img)').clone().attr({ rel: 'gallery', title: '' })
        ).hide().appendTo('body');
        //Trigger box (on the right one)
        $galleryCont.children().colorbox().filter('[href="'+$(this).attr('href')+'"]').first().click();
      }
    }
  });


  //Show a quick generic text popup above an element
  window.showQuickPopup = function(message, $origin){
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
    $('body').append($popup);
    $popup.css('margin-top', - $popup.outerHeight() - 10);
    $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
      $(this).remove();
    });
  };

  
  //Ajax add-to-cart
  var shopifyAjaxAddURL = '/cart/add.js';
  var shopifyAjaxCartURL = '/cart.js';
  var shopifyAjaxStorePageURL = '/search';

  $(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX)', function(e) {
    if(mobileLayout()) {
      return true;
    }
    var $form = $(this);
    //Disable add button
    $form.find(':submit').attr('disabled', 'disabled').each(function(){
      var contentFunc = $(this).is('button') ? 'html' : 'val';
      $(this).data('previous-value', $(this)[contentFunc]())[contentFunc]("Translation missing: en.products.product.adding_to_cart");
    });

    //Add to cart
    $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
      //Enable add button
      $form.find(':submit').each(function(){
        $btn = $(this);
        var contentFunc = $(this).is('button') ? 'html' : 'val';
        //Set to 'DONE', alter button style, wait a few secs, revert to normal
        $btn[contentFunc]("Translation missing: en.products.product.added_to_cart");
        setTimeout(function(){
          $btn.removeAttr('disabled')[contentFunc]($btn.data('previous-value'));
        }, 4000);
      });

      //Update header summary
      $.get(shopifyAjaxStorePageURL, function(data){
        var cartSummarySelector = '#pageheader .checkout-link';
        var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find(cartSummarySelector);
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);
        //Show cart dropdown for a few seconds
        $newCartObj.addClass('reveal');
        setTimeout(function(){
          $newCartObj.removeClass('reveal');
        }, 4000);
      });


    }, 'text').error(function(data) {
      //Enable add button
      var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function(){
        var $btn = $(this);
        var contentFunc = $btn.is('button') ? 'html' : 'val';
        $btn[contentFunc]($btn.data('previous-value'))
      }).first();

      //Not added, show message
      if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
        var jsonRes = $.parseJSON(data.responseText);
        window.showQuickPopup(jsonRes.description, $firstBtn);
      } else {
        //Some unknown error? Disable ajax and submit the old-fashioned way.
        $form.addClass('noAJAX');
        $form.submit();
      }
    });
    return false;
  });
  

  //General lightbox for all
  $('a[rel=lightbox]').colorbox();

  //Immmediately select contents when focussing on some inputs
  $(document).on('focusin click', 'input.select-on-focus', function(){
    $(this).select();
  }).on('mouseup', 'input.select-on-focus', function(e){
    e.preventDefault(); //Prevent mouseup killing select()
  });

  //Product blocks to have consistent heights, purely visual
  $(window).on('load debouncedresize checkcaptionheights', function(){
    var $firstBlock = $('.prod-block:first');
    var productsPerRow = Math.round($firstBlock.parent().width() / $firstBlock.width());

    var $caps = $('.prod-caption');
    for(var i = 0; i < Math.ceil($caps.length / productsPerRow); i++) {
      var $toProcess = $caps.slice(i*productsPerRow, (i+1)*productsPerRow);
      var h = 0;
      $toProcess.each(function(){
        var ch = $(this).children().outerHeight();
        if(ch > h) h = ch;
      }).height(h);
    }
  }).trigger('checkcaptionheights');
});
	
 
  $(document).ready(function(){
    // $('.image-zoom')
//     .wrap('<span style="display:inline-block"></span>')
//     .css('display', 'block')
//     .parent()
//     .zoom({
//       url: $(this).find('img').attr('data-zoom')
//     });
    if($("#product-rbottom-text").length)
    {
      var productHandle = $('#product-rbottom-text').attr("product-handle");
      if(typeof productHandle != "undefined" && productHandle != null && productHandle != "" && productHandle == "weather-clock-small")
      {
        $('#product-rbottom-text').Cuttr({
            //options here
            truncate: 'words',
          	ending: '',
            length: 31,
            readMore: true,
            readMoreBtnTag: 'a',
            readMoreText: 'Read More',
            readLessText: 'Read Less'
        });
      }
      else if(typeof productHandle != "undefined" && productHandle != null && productHandle != "" && productHandle == "preloved-weather-clock")
      {
        $('#product-rbottom-text').Cuttr({
            //options here
            truncate: 'words',
          	ending: '',
            length: 31,
            readMore: true,
            readMoreBtnTag: 'a',
            readMoreText: 'Read More',
            readLessText: 'Read Less'
        });
      }
      else
      {
        $('#product-rbottom-text').Cuttr({
            //options here
            truncate: 'words',
            length: 60,
            readMore: true,
            readMoreBtnTag: 'a',
            readMoreText: 'Read More',
            readLessText: 'Read Less'
        });
      }
    }
  });
 


   /*ESHOP GUIDE*/
 jQuery(function($) {
    window.VIG = window.VIG || {};
    VIG.VariantChangeCallback = function(){
      $('.slick-initialized').each(function(index,slider){
		
           $(slider).slick("slickFilter",function(){
            if($(this).css("display")!="none"){
              return true;
            }
          });
      })
      
    };
    VIG.BeforeVariantChange = function(){
      $('.slick-initialized').each(function(index,slider){

			
           $(slider).slick("slickUnfilter");
      })
    };
   
   
    $('.slider-nav .slick-track .slick-slide').click(function(){
     $('.slider-for .slick-track .slick-slide').removeClass("slick-current");
    // $(this).addClass("slick-current");
   	 var index = $(this).attr("data-slick-index");
      
	var rindex = $(".slider-for .slick-track .slick-slide[data-slick-index='"+index+"']").index();
      
     $(".slider-for").slick("slickGoTo",rindex);
   })
    
    
  });  
  /*ESHOP GUIDE END*/
  
    /*Heading Title Fix starts*/
   jQuery(function($) {
     if(jQuery('.its-a-page').length > 0) {
       var title_height = jQuery('.its-a-page h1.title').height();
       if(jQuery(window).width() < 600) {
         title_height = title_height + 30;
       }
       
       var container_height = jQuery('.its-a-page').height();
       
       if(title_height >= container_height) {
         jQuery('.its-a-page').height(title_height + 50);
       }
     }
     
     jQuery("[href='#product-tabs-href']").on('click', function(e) {
       e.preventDefault();
       jQuery([document.documentElement, document.body]).animate({
         scrollTop: jQuery("#product-tabs-href").offset().top - 20
       }, 1000);
     });
   });
   
   jQuery(window).resize(function() {
     if(jQuery('.its-a-page').length > 0) {
       var title_height = jQuery('.its-a-page h1.title').height();
       if(jQuery(window).width() < 600) {
         title_height = title_height + 30;
       }
       
       var container_height = jQuery('.its-a-page').height();
       
       if(title_height >= container_height) {
         jQuery('.its-a-page').height(title_height + 50);
       }
     }
   });
    /*Heading Title Fix starts*/
    
/*11 june 2021 website changes start*/
function formatState (state) {
  if (!state.id) {
    return state.text;
  }
  var baseUrl = state.element.value;
  var flagUrl = $(".currency-image-lists li."+baseUrl).attr("data-image");
  var $state = $(
    '<span class="dropdown-image"><img src="' + flagUrl + '" class="img-flag" /> </span><span class="dropdown-text">' + state.text + '</span>'
  );
  return $state;
};
jQuery(document).ready(function() {
  if($(".desktop-currency").length > 0)
  {
    $(".desktop-currency").select2({
      templateResult: formatState,
      templateSelection: formatState,
      minimumResultsForSearch: -1
    });
  }
  if($(".mobile-currency").length > 0)
  {
    $(".mobile-currency").select2({
      templateResult: formatState,
      templateSelection: formatState,
      minimumResultsForSearch: -1
    });
  }
});
jQuery(window).on("load", function() {
  var type = window.location.hash.substr(1);
  if(typeof type != "undefined" && type != null && type != "")
  {
    if($("#"+type).length > 0)
    {
    	$('html, body').animate({
          scrollTop: $("#"+type).offset().top - 100
            }, 1500, function(){        
        });
    }
    
  }
});
/*11 june 2021 website changes end*/
/* 08 Aug 2022 Header and Homepage Changes starts */
jQuery(document).ready(function(){
   if($('.home-tide-clock-images-for').length > 0)
   {
      $('.home-tide-clock-images-for').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         lazyLoad: 'ondemand',
         arrows: false,
         fade: true,
         infinite: false,
         asNavFor: '.home-tide-clock-images-nav'
      });
      $('.home-tide-clock-images-nav').slick({
         slidesToShow: 4,
         slidesToScroll: 1,
         lazyLoad: 'ondemand',
         dots: false,
         infinite: false,
         swipe: true,
         focusOnSelect: true,
         vertical:true,
         asNavFor: '.home-tide-clock-images-for',
         responsive: [
            {
               breakpoint: 768,
               settings: {
                  vertical:false
               }
            }
         ]
      });
   }
   if($('.home-testimonials-details-slider .home-single-testimonial-inner').length > 0)
   {
      $('.home-testimonials-details-slider').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         lazyLoad: 'ondemand',
         arrows: true,
         autoplay: true,
         focusOnSelect: true,
         fade: true,
         infinite: false,
         dots: true,
      });
      $('.home-testimonials-details-slider .slick-next').attr('aria-label', $('.home-testimonials-details-slider').data('next-slide-label'));
      $('.home-testimonials-details-slider .slick-prev').attr('aria-label', $('.home-testimonials-details-slider').data('prev-slide-label'));
   }
   jQuery(".home-tide-clock-form-variant select").on("change", function(){
      var getOptionValues = "";
      jQuery(this).parents(".home-tide-clock-form-inner-wrapper").find(".home-tide-clock-form-variant").each(function(){
         var getSingleOptionValue = $(this).find("select").val();
         if(typeof getOptionValues != "undefined" && getOptionValues != null && getOptionValues != "")
         {
            getOptionValues += " / "+getSingleOptionValue;
         }
         else
         {
            getOptionValues += getSingleOptionValue;
         }
      });
      if(typeof getOptionValues != "undefined" && getOptionValues != null && getOptionValues != "")
      {
         var isMatched = false;
         var buttonText = $(this).parents("form").find(".home-tide-clock-form-button button").attr("data-button-text");
         var buttonSoldOutText = $(this).parents("form").find(".home-tide-clock-form-button button").attr("data-button-sold-out-text");
         $(this).parents("form").find("#product-select option").each(function(){
            var matchValue = $(this).attr("data-match");
            if(matchValue == getOptionValues)
            {
               var isAvailable = $(this).attr("data-available");
               var price = $(this).attr("data-price");
               if(isAvailable == "true")
               {
                  $(this).parents("form").find(".home-tide-clock-form-button button").prop("disabled", false);
                  $(this).parents("form").find(".home-tide-clock-form-button button .button-text").html("");
                  $(this).parents("form").find(".home-tide-clock-form-button button .button-text").html(buttonText);
                  $(this).parents("form").find(".home-tide-clock-form-button button .product-price").html("");
                  $(this).parents("form").find(".home-tide-clock-form-button button .product-price").html(price);
                  $(this).parents("form").find("#product-select option").removeAttr("selected");
                  $(this).attr("selected", "selected");
                  $(this).prop("selected", true);
               }
               else
               {
                  $(this).parents("form").find(".home-tide-clock-form-button button").prop("disabled", true);
                  $(this).parents("form").find(".home-tide-clock-form-button button .button-text").html("");
                  $(this).parents("form").find(".home-tide-clock-form-button button .button-text").html(buttonSoldOutText);
                  $(this).parents("form").find(".home-tide-clock-form-button button .product-price").html("");
                  $(this).parents("form").find(".home-tide-clock-form-button button .product-price").html(price);
               }
               isMatched = true;
            }
         });
         if(!isMatched)
         {
            $(this).parents("form").find(".home-tide-clock-form-button button").prop("disabled", false);
            $(this).parents("form").find(".home-tide-clock-form-button button .button-text").html("");
            $(this).parents("form").find(".home-tide-clock-form-button button .button-text").html(buttonText);
         }
      }
   });
   jQuery(".home-clock-details-single-tab > a").on("click", function(e){
      e.preventDefault();
      if(jQuery(this).parent().hasClass("active"))
      {
         jQuery(this).parent().removeClass("active");
         jQuery(this).parent().find(".tab-description").slideUp();
      }
      else
      {
         jQuery(".home-clock-details-single-tab").removeClass("active");
         jQuery(".home-clock-details-single-tab .tab-description").slideUp();
         jQuery(this).parent().addClass("active");
         jQuery(this).parent().find(".tab-description").slideDown();
      }
   });
   if(jQuery(".lp-single-bespoke-list").length > 0)
   {
      jQuery(".lp-single-bespoke-list").matchHeight({
         byRow: true
      });
   }
   if(jQuery(".lp-single-bespoke-description").length > 0)
   {
      jQuery(".lp-single-bespoke-description").matchHeight({
         byRow: true
      });
   }
   if(jQuery(".lp-single-bespoke-title").length > 0)
   {
      jQuery(".lp-single-bespoke-title").matchHeight({
         byRow: true
      });
   }
   if($('.home-single-wall-images img').length > 0)
   {
      if($(window).width() < 768)
      {
         $('.home-wall-images-row').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            infinite: false,
            swipe: true,
            focusOnSelect: true,
         });
      }
   }
   if(jQuery('.home-location-wise-tide-clocks-slider-nav .home-location-wise-tide-clocks-slider-single-nav').length > 0 &&
      jQuery('.home-location-wise-tide-clocks-slider-for .home-location-wise-tide-clocks-slider-single-for').length > 0)
   {
      jQuery('.home-location-wise-tide-clocks-slider-for').on('init', function(event, slick){
          setTimeout(function(){
            var sliderHeight = jQuery(".home-location-wise-tide-clocks-slider-for-wrapper").outerHeight();
            jQuery(".home-location-wise-tide-clocks-slider-wrapper").css("height", sliderHeight+"px");
          }, 1000);
      });
      jQuery('.home-location-wise-tide-clocks-slider-for').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         lazyLoad: 'ondemand',
         arrows: true,
         fade: true,
         dots: false,
         infinite: true,
         asNavFor: '.home-location-wise-tide-clocks-slider-nav'
      });
      jQuery('.home-location-wise-tide-clocks-slider-nav').slick({
         slidesToShow: 3,
         slidesToScroll: 1,
         lazyLoad: 'ondemand',
         dots: false,
         arrows: false,
         centerMode: true,
         centerPadding: '12%',
         infinite: true,
         swipe: true,
         focusOnSelect: true,
         responsive: [
            {
               breakpoint: 767,
               settings: {
                  slidesToShow: 1,
                  centerPadding: '20%',
               }
            }
         ]
      });
      jQuery('.home-location-wise-tide-clocks-slider-nav .slick-track .slick-slide').click(function(){
         jQuery('.home-location-wise-tide-clocks-slider-for .slick-track .slick-slide').removeClass("slick-current");
         var newIndex = jQuery(this).attr("data-slick-index");
         var rewNewIndex = jQuery(".home-location-wise-tide-clocks-slider-for .slick-track .slick-slide[data-slick-index='"+newIndex+"']").index();
         jQuery(".home-location-wise-tide-clocks-slider-for").slick("slickGoTo",rewNewIndex);
      });
   }
   $('.home-clock-details-faqs-wrapper a, .home-tide-clock-images-more-clocks-inner a, .step-6-link-container a').on('click', function (e) {
      e.preventDefault();
      var jump = jQuery(this).attr('href');
      if(jump.indexOf("#") != -1)
      {
          var arr = jump.split('#');
          if($("#"+arr[1]).length)
          {
            var newJump = "#"+arr[1];
            var new_position = jQuery(newJump).offset();
            var scroll = 0;
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 900, function(){
                var new_position_new = jQuery(newJump).offset();
                jQuery('html, body').stop().animate({ scrollTop: new_position_new.top + scroll }, 500);
            });
         }
         else
         {
            window.location.href = jump;
         }
      }
      else
      {
         window.location.href = jump;
      }
   });
   $('.home-new-one a').on('click', function (e) {
      e.preventDefault();
      var jump = jQuery(this).attr('href');
      if(jump.indexOf("#") != -1)
      {
          var arr = jump.split('#');
          if($("#"+arr[1]).length)
          {
            var newJump = "#"+arr[1];
            var new_position = jQuery(newJump).offset();
            var scroll = 0;
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 900, function(){
                var new_position_new = jQuery(newJump).offset();
                jQuery('html, body').stop().animate({ scrollTop: new_position_new.top + scroll }, 500);
            });
         }
         else
         {
            window.location.href = jump;
         }
      }
      else
      {
         window.location.href = jump;
      }
   });
   $(".submit-button-wrapper button").on("click", function(e){
      e.preventDefault();
      var getcustomLocation = $(".custom-location").val();
      var getcustomRegion = $(".custom-location-region").val();
      var getcustomName = $(".custom-first-name").val();
      var getcustomEmail = $(".custom-email").val();
      var isError = false;
      if(!$(this).parents("form").find(".form-group.hide-for-now").is(":visible"))
      {
        if(typeof getcustomLocation != "undefined" && getcustomLocation != null && getcustomLocation != "")
        {
           $(".home-newsletter-form").attr("data-location", getcustomLocation);
           $(this).parents("form").find(".klaviyo_messages .error_message").html("");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           $(this).parents("form").find(".form-group.hide-for-now").slideDown();
           isError = false;
        }
        else
        {
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .error_message").html("Location field is required");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideDown();
           isError = true;
           return false;
        }  
      }
      else
      {
        if(typeof getcustomLocation != "undefined" && getcustomLocation != null && getcustomLocation != "")
        {
           $(this).parents("form").find(".klaviyo_messages .error_message").html("");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           isError = false;
        }
        else
        {
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .error_message").html("Location field is required");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideDown();
           isError = true;
           return false;
        }
        if(typeof getcustomRegion != "undefined" && getcustomRegion != null && getcustomRegion != "")
        {
           $(this).parents("form").find(".klaviyo_messages .error_message").html("");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           isError = false;
        }
        else
        {
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .error_message").html("Can you please add County/Region/State?");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideDown();
           isError = true;
           return false;
        }
        if(typeof getcustomName != "undefined" && getcustomName != null && getcustomName != "")
        {
           $(this).parents("form").find(".klaviyo_messages .error_message").html("");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           isError = false;
        }
        else
        {
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .error_message").html("Can we please have your name?");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideDown();
           isError = true;
           return false;
        }
        if(typeof getcustomEmail != "undefined" && getcustomEmail != null && getcustomEmail != "")
        {
           $(this).parents("form").find(".klaviyo_messages .error_message").html("");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           isError = false;
        }
        else
        {
           $(this).parents("form").find(".klaviyo_messages .success_message").html("");
           $(this).parents("form").find(".klaviyo_messages .success_message").slideUp();
           $(this).parents("form").find(".klaviyo_messages .error_message").html("Can we please have your email address so we can advise if we create a design to your request?");
           $(this).parents("form").find(".klaviyo_messages .error_message").slideDown();
           isError = true;
           return false;
        }
        if(isError)
        {
  
        }
        else
        {
           $(this).parents("form").submit();
        }
      }
      
   });
});
jQuery(document).ready(function(){
   if(jQuery(".lp-single-bespoke-list").length > 0)
   {
      jQuery(".lp-single-bespoke-list").removeAttr("style");
      
         jQuery(".lp-single-bespoke-list").matchHeight({
            byRow: true
         });
      
   }
   if(jQuery(".lp-single-bespoke-description").length > 0)
   {
      jQuery(".lp-single-bespoke-description").removeAttr("style");
      
         jQuery(".lp-single-bespoke-description").matchHeight({
            byRow: true
         });
      
   }
   if(jQuery(".lp-single-bespoke-title").length > 0)
   {
      jQuery(".lp-single-bespoke-title").removeAttr("style");
      
         jQuery(".lp-single-bespoke-title").matchHeight({
            byRow: true
         });
      
   }
});
jQuery(window).on("resize", function(){
   if(jQuery(".lp-single-bespoke-list").length > 0)
   {
      jQuery(".lp-single-bespoke-list").removeAttr("style");
      setTimeout(function(){
         jQuery(".lp-single-bespoke-list").matchHeight({
            byRow: true
         });
      }, 2000);
   }
   if(jQuery(".lp-single-bespoke-description").length > 0)
   {
      jQuery(".lp-single-bespoke-description").removeAttr("style");
      setTimeout(function(){
         jQuery(".lp-single-bespoke-description").matchHeight({
            byRow: true
         });
      }, 2000);
   }
   if(jQuery(".lp-single-bespoke-title").length > 0)
   {
      jQuery(".lp-single-bespoke-title").removeAttr("style");
      setTimeout(function(){
         jQuery(".lp-single-bespoke-title").matchHeight({
            byRow: true
         });
      }, 2000);
   }
   if(jQuery('.home-location-wise-tide-clocks-slider-nav .home-location-wise-tide-clocks-slider-single-nav').length > 0 &&
      jQuery('.home-location-wise-tide-clocks-slider-for .home-location-wise-tide-clocks-slider-single-for').length > 0)
   {
      jQuery('.home-location-wise-tide-clocks-slider-for')[0].slick.refresh();
      jQuery('.home-location-wise-tide-clocks-slider-nav')[0].slick.refresh();
      setTimeout(function(){
         var sliderHeight = jQuery(".home-location-wise-tide-clocks-slider-for-wrapper").outerHeight();
         jQuery(".home-location-wise-tide-clocks-slider-wrapper").css("height", sliderHeight+"px");
      }, 1000);
   }
});
/* 08 Aug 2022 Header and Homepage Changes ends */ 
/* 08 Sep 2022 Header and Website Changes starts */
var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};
function copyToClipboard(element) {
   var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).attr("href")).select();
    document.execCommand("copy");
    $temp.remove();
    alert("Copied"); 
}
jQuery(document).ready(function(){
   $(".home-newsletter-success-popup-social-links-title a").on("click", function(e){
    e.preventDefault();
    var currentTag= $(this);
    copyToClipboard(currentTag);
  });
   if(jQuery(".product-list .prod-block").length > 0)
   {
      jQuery(".product-list .prod-block").matchHeight({
         byRow: true
      });
   }
});
jQuery(window).on("load", function(){
   if(jQuery(".product-list .prod-block").length > 0)
   {
      jQuery(".product-list .prod-block").removeAttr("style");
      setTimeout(function(){
         jQuery(".product-list .prod-block").matchHeight({
            byRow: true
         });
      }, 2000);
   }
   var URLhash = window.location.hash;
   var URLHashParts = URLhash.split('#');
   if (URLHashParts.length > 1) {
       if(URLHashParts.pop() == "okeReviews-reviews")
       {
         setTimeout(function(){
            waitForEl(".okeReviews-reviewsSummary", function() {
              $(document).find(".okeReviews-reviewsSummary").trigger("click");
            });
            },3000);
       }
   }
});
jQuery(window).on("resize", function(){
   if(jQuery(".product-list .prod-block").length > 0)
   {
      jQuery(".product-list .prod-block").removeAttr("style");
      setTimeout(function(){
         jQuery(".product-list .prod-block").matchHeight({
            byRow: true
         });
      }, 2000);
   }
});
/* 08 Sep 2022 Header and Website Changes ends */
/* 20 Sep 2022 Website Changes starts */
jQuery(document).ready(function(){
   $(".main-cart-items-list-product-quantity-box").on("click", function(){
      if($(this).find("ul").is(":visible"))
      {
         $(this).find("ul").slideUp();
      }
      else
      {
         $(".main-cart-items-list-product-quantity-box ul").slideUp();
         $(this).find("ul").slideDown();
      }
   });
   $(".main-cart-items-list-product-remove a").on("click", function(e){
      e.preventDefault();
      var currentKey = $(this).parents(".main-cart-items-list-product").attr("data-key");
      $.ajax({
         url: '/cart/change.js',
         dataType: 'json',
         type: 'post',
         data: { quantity: 0, id: currentKey },
         success: function (data) {
            window.location = "/cart";
          },
         error: function(XMLHttpRequest) {
           alert(XMLHttpRequest.responseJSON.description);
         }
      });
   });
   $(".main-cart-items-list-product-quantity-box ul li a").on("click", function(e){
      e.preventDefault();
      var changedQuantity = $(this).attr("data-quantity");
      changedQuantity = parseInt(changedQuantity);
      var currentQuantity = $(this).parent().parent().parent().find("p").text();
      currentQuantity = parseInt(currentQuantity);
      if(currentQuantity != changedQuantity)
      {
         var currentKey = $(this).parents(".main-cart-items-list-product").attr("data-key");
         $(this).parent().parent().parent().find("p").html("");
         $(this).parent().parent().parent().find("p").html(changedQuantity);
         $.ajax({
             url: '/cart/change.js',
             dataType: 'json',
             type: 'post',
             data: { quantity: changedQuantity, id: currentKey },
             success: function (data) {
               window.location = "/cart";
             },
             error: function(XMLHttpRequest) {
              alert(XMLHttpRequest.responseJSON.description);
            }
         });
      }
   }); 
});
/* 20 Sep 2022 Website Changes ends */
$(window).on("resize", function(){
 if($(".home-location-wise-tide-clocks-slider-single-block-details").length > 0)
 {
   $(".home-location-wise-tide-clocks-slider-single-block-details").removeAttr("style");
   setTimeout(function(){
      $(".home-location-wise-tide-clocks-slider-single-block-details").matchHeight({
         byRow: true
      });
   }, 800);
 }
});
$(document).ready(function() {
   if($(".home-location-wise-tide-clocks-slider-single-block-details").length > 0)
   {
      $(".lp-single-bespoke-list").matchHeight({
         byRow: true
      });
   }
   if($(".home-location-wise-tide-clocks-slider-single-block-details").length > 0)
   {
      $(".home-location-wise-tide-clocks-slider-single-block-details").removeAttr("style");
      $(".home-location-wise-tide-clocks-slider-single-block-details").matchHeight({
         byRow: true
      });
      
   }
   if(document.querySelector(".swiper"))
   {
    const swiper = new Swiper('.swiper', {
      slidesPerView: 3,
      spaceBetween: 24,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      }, 
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 700,
      },
      mousewheel: {
        enabled: true,
        // enabled: false,
        sensitivity: 5.5,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          freeMode: {
            enabled: false
          },
          scrollbar: {
            dragSize: 100,
          },
          mousewheel: {
            enabled: false
          }
        },
        768: {
          slidesPerView: 2,
          freeMode: {
            enabled: false
          },
          scrollbar: {
            dragSize: 300,
          },
          mousewheel: {
            enabled: false
          }
        },
        991: {
          slidesPerView: 3,
          // freeMode: false,
          scrollbar: {
            dragSize: 700
          }
        }
      }
    });

    const nextBtn = document.querySelector(".swiper-button-next");
    const prevBtn = document.querySelector(".swiper-button-prev");

    if (nextBtn) {
      nextBtn.setAttribute("aria-label", document.querySelector(".swiper").dataset.nextSlideLabel);
    }

    if (prevBtn) {
      prevBtn.setAttribute("aria-label", document.querySelector(".swiper").dataset.prevSlideLabel);
    }
   }
 if($('.home-location-wise-tide-clocks-slider-wrapper .swiper').length > 0)
 {
   $('.home-location-wise-tide-clocks-slider-wrapper .swiper').mouseenter(function() {
       $(this).addClass("custom-show-arrows");
   });
   $('.home-location-wise-tide-clocks-slider-wrapper .swiper').mouseleave(function() {
       $(this).removeClass("custom-show-arrows");
   });
 }
 if($('.home-location-wise-tide-clocks-wrapper .tide-clock-changes-slider').length > 0){
  const $slider = $('.home-location-wise-tide-clocks-wrapper .tide-clock-changes-slider');
  const prevLabel = $slider.data('prev-slide-label');
  const nextLabel = $slider.data('next-slide-label');
  const dotsLabel = $slider.data('dots-slide-label');
   $('.home-location-wise-tide-clocks-wrapper .tide-clock-changes-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: true,
     autoplay: false,
     infinite: false,
     centerMode: false,
     dots: true,
     prevArrow: `<button type="button" class="slick-arrow prev-arrow" aria-label="${prevLabel}"><svg width="52" height="60" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="-1" width="50" height="58" transform="matrix(-1 0 0 1 52 2)" fill="white"/><path d="M21.5 30L30.5 21" stroke="#D9D9D9" stroke-width="3" stroke-linecap="round"/><path d="M21.5 30L30.5 39" stroke="#D9D9D9" stroke-width="3" stroke-linecap="round"/><rect x="1" y="-1" width="50" height="58" transform="matrix(-1 0 0 1 52 2)" stroke="#D9D9D9" stroke-width="2"/></svg></button>`,
     nextArrow: `<button type="button" class="slick-arrow next-arrow" aria-label="${nextLabel}"><svg width="52" height="60" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="50" height="58" fill="white"/><path d="M30.5 30L21.5 21" stroke="#D9D9D9" stroke-width="3" stroke-linecap="round"/><path d="M30.5 30L21.5 39" stroke="#D9D9D9" stroke-width="3" stroke-linecap="round"/><rect x="1" y="1" width="50" height="58" stroke="#D9D9D9" stroke-width="2"/></svg></button>`
    });
    // Add aria-label to actual slick dot buttons
    $('.home-location-wise-tide-clocks-wrapper .tide-clock-changes-slider')
    .find('.slick-dots li button')
    .each(function(index) {
      $(this).attr('aria-label', `${dotsLabel} ${index + 1}`);
    });     
 }
if($('[data-fancybox="gallery"]').length > 0)
  {
    $('[data-fancybox="gallery"]').fancybox({
      afterClose : function(instance, current) {
        setTimeout(function(){
          $('.product-photos .mainpic').slick('refresh');
        },500);
      }
    });
  }
});
$(document).ready(function() {
  if($(window).width() > 767)
  {
     $('.home-banner-video .head-img-cont.vid').mouseenter(function() {
         if($(this).find(".video-buttons-wrapper .btn").length > 0)
         {
           $(this).find(".video-buttons-wrapper").fadeIn();
         }
     });
     $('.home-banner-video .head-img-cont.vid').mouseleave(function() {
         if($(this).find(".video-buttons-wrapper .btn").length > 0)
         {
           $(this).find(".video-buttons-wrapper").fadeOut();
         }
     }); 
  }
});
$(window).on("load", function(){
  if($("#customNewsletter").length > 0)
  {
    var getLocation = getUrlParameter('location');
    if(typeof getLocation != "undefined" && getLocation != null && getLocation != "" && getLocation == "true")
    {
      setTimeout(function(){
        var jump = "#customNewsletter";
        if(jump.indexOf("#") != -1)
        {
            var arr = jump.split('#');
            if($("#"+arr[1]).length)
            {
              var newJump = "#"+arr[1];
              var new_position = jQuery(newJump).offset();
              var scroll = 0;
              jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 900, function(){
                  var new_position_new = jQuery(newJump).offset();
                  jQuery('html, body').stop().animate({ scrollTop: new_position_new.top + scroll }, 500);
              });
           }
           else
           {
              window.location.href = jump;
           }
        }
        else
        {
           window.location.href = jump;
        }
      },1000);
    }
  }
});
$(document).ready(function(){
  // if($("body.template-index").length > 0)
  // {
  //   waitForEl(".tolstoy-widget", function() {
  //     $(document).find(".tolstoy-widget").attr('style', 'z-index: 9 !important;');
  //   });
  //   var mainCurrentScroll = $(window).scrollTop();
  //   if(mainCurrentScroll > 550)
  //   {
  //     $(document).find(".tolstoy-widget").attr('style', 'z-index: 999999 !important;');
  //   }
  //   else
  //   {
  //     $(document).find(".tolstoy-widget").attr('style', 'z-index: 999999 !important;');
  //   }
  //   $(window).on("scroll", function(){
  //     var currentScroll = $(window).scrollTop();
  //     if(currentScroll > 550)
  //     {
  //       $(document).find(".tolstoy-widget").attr('style', 'z-index: 999999 !important;');
  //     }
  //     else
  //     {
  //       $(document).find(".tolstoy-widget").attr('style', 'z-index: 999999 !important;');
  //     }
  //   });
  // }
  if($(".new-infobar").length > 0)
  {
    
  }
  else
  {
    if($(".infoBar").length > 0)
    {
      var getInfoBarHtml = $(".infoBar").html();  
      var newInfoHtml = '';
      newInfoHtml += '<div class="new-infobar">';
        newInfoHtml += getInfoBarHtml;
      newInfoHtml += '</div>';
      $(newInfoHtml).insertAfter("form .product-form");
    }
  }
});
function customSoldOutOptions()
{
  if(jQuery(".product-color-properties select").length > 0)
  {
    if(jQuery("#product-variants #product-select").length > 0)
    {
      var currentClockValue = jQuery("#product-select-option-1").val();
      jQuery("#product-variants #product-select option").each(function(){
          var dataMatch = jQuery(this).attr("data-match");
          var dataAvailable = jQuery(this).attr("data-available");
          if (dataMatch && dataMatch.includes(currentClockValue))
          {
            if(dataAvailable == "false")
            {
              jQuery(".product-color-properties select option").each(function(){
                jQuery(this).addClass("not-available");
              });
              // return true;
            }
            else
            {
              jQuery(".product-color-properties select option").each(function(){
                jQuery(this).removeClass("not-available");
              });
            }
          }
      });
      jQuery("#product-select-option-1 option").each(function(index, ele){
          var currentValue = jQuery(this).attr("value");
        jQuery("#product-variants #product-select option").each(function(){
          var dataMatch = jQuery(this).attr("data-match");
          var dataAvailable = jQuery(this).attr("data-available");
          if (dataMatch && dataMatch.includes(currentValue))
          {
            if(dataAvailable == "false")
            {
              jQuery(ele).addClass("not-available");
              // return true;
            }
          }
        }); 
      });
    }
  }
}
jQuery(document).ready(function () {
    jQuery(".product-color-properties select").on("change", function(){
      setTimeout(function(){
        customSoldOutOptions();
      }, 500);
    });
    waitForEl("#product-variants .single-option-selector option", function() {
      customSoldOutOptions();
      jQuery("#product-select-option-1").on("change", function(){
        setTimeout(function(){
          customSoldOutOptions();
        }, 500);
      });
      if(jQuery("body.template-product-fantasy-weather-clock").length > 0 || jQuery("body.template-product-wallace-gromit-weather").length > 0 ||
        jQuery("body.template-product-hokusai-tide-clock").length > 0 || jQuery("body.template-product-hiroshige-weather-clock").length > 0)
      {
        if(jQuery("#product-variants #product-select").length > 0)
        {
          jQuery("#product-variants #product-select option").each(function(){
            var dataMatch = jQuery(this).attr("data-match");
            var dataAvailable = jQuery(this).attr("data-available");
            jQuery("#product-variants .single-option-selector option").each(function(){
              var currentValue = jQuery(this).attr("value");
              if(currentValue == dataMatch)
              {
                if(dataAvailable == "false")
                {
                  jQuery(this).addClass("not-available");
                }
              }
            }); 
          });
        }
      }
      if(jQuery("body.template-product-papercut-forest").length > 0)
      {
        if(jQuery("#product-variants #product-select").length > 0)
        {
          jQuery("#product-variants #product-select option").each(function(){
            var dataMatch = jQuery(this).attr("data-match");
            var dataAvailable = jQuery(this).attr("data-available");
            jQuery("#product-variants .single-option-selector option").each(function(){
              var currentValue = jQuery(this).attr("value");
              if(currentValue == dataMatch)
              {
                if(dataAvailable == "false")
                {
                  jQuery(this).prop("disabled", true);
                }
              }
            }); 
          });
        }
      }
    });
    function updateProgressIndicatorCollection(slick, currentSlide) {
      var progressIndicator = $('.bwb-our-customers-slider__progress-indicator');
      var slideWidth = 100 / slick.slideCount;
      var leftPosition = slideWidth * currentSlide;
      progressIndicator.css('width', slideWidth + '%');
      progressIndicator.css('left', leftPosition + '%');
    }
  
    $('.bwb-our-customers-slider__single-item').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      var i = (currentSlide ? currentSlide : 0);
      updateProgressIndicatorCollection(slick, i);
    });
  
    $('.bwb-our-customers-slider__single-item').slick({
      slidesToShow: 1,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow"><svg width="15" height="18" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.80249 10.6199L0.999157 6.81655C0.54999 6.36738 0.54999 5.63238 0.999157 5.18322L4.80249 1.37988" stroke="white" stroke-width="1.16667" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow"><svg width="15" height="18" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.19751 10.6199L5.00084 6.81655C5.45001 6.36738 5.45001 5.63238 5.00084 5.18322L1.19751 1.37988" stroke="white" stroke-width="1.16667" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 768, // settings for screens below 768px width
          settings: {
            slidesToShow: 1,
            arrows: false, // Hide arrows on mobile view
          }
        },
        {
          breakpoint: 480, // settings for screens below 480px width
          settings: {
            slidesToShow: 1,
            arrows: false, // Hide arrows on mobile view
          }
        }
      ]
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
  const productColorBoxes = document.querySelectorAll('.bwb-product-color');

  productColorBoxes.forEach(box => {
    const colorSvgs = box.querySelectorAll('.color-svg');

    colorSvgs.forEach(svg => {
      svg.addEventListener('click', function() {
        // Remove 'selected' class from all SVGs within this box
        colorSvgs.forEach(s => s.classList.remove('selected'));

        // Add 'selected' class to the clicked SVG
        this.classList.add('selected');
      });
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
    const products = document.querySelectorAll('.bwb-product-filter__media');

    products.forEach(product => {
      const mobileImage = product.querySelector('.mobile-view img');
      const buttons = product.querySelectorAll('.image-button');

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const imageNumber = button.getAttribute('data-image');
          const newImageSrc = product.getAttribute(`data-image${imageNumber}`);
          mobileImage.src = newImageSrc;

          // Remove active class from all buttons
          buttons.forEach(btn => btn.classList.remove('active'));

          // Add active class to the clicked button
          button.classList.add('active');
        });
      });
    });
  });

  // $(function () {
  // Dropdown toggle





